const data = {
	"width": 32,
	"height": 32,
	"body": "<path fill=\"currentColor\" d=\"m30.336 12.547l-10.172-1.074L16 2.133l-4.164 9.34l-10.172 1.074l7.598 6.848L7.14 29.398L16 24.29l8.86 5.11l-2.122-10.004z\"/>"
};
exports.__esModule = true;
exports.default = data;
